import {addIndexFace,
  } from '../Interfaces/Interfaces';
  import * as yup from 'yup';
  
    
  // const addObjectiveValues:AddObjectiveFace={
  //     objectiveDescription:'',
  //     descriptions:'',
  //     levelId:'',
  //     periodId:'',
  //     responsibleId:'',
  //     teamID:'',
  //     teamsOrPersonsId:'',
  //     TheReasonImportant:'',
  //     weight:''
  // }
  
  
  
  
   
  const addIndexSchema = yup.object().shape({
    // name:yup.string().required('شرح شاخص اجباری است'),
    // categoryIds:yup.string().required('دسته بندی اجباری است'),
    // responsibleId:yup.string().required(''),
    // definitionLevelId:yup.string().required(''),
    // weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
  });
  
  
//   const editObjectiveSchema = yup.object().shape({
//     name:yup.string().required(''),
//     periodId:yup.string().required(''),
//     responsibleId:yup.string().required(''),
//     definitionLevelId:yup.string().required(''),
//     weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
//   });
  
  // name:string,
  // responsibleId:string,
  // pointingSystemType:string,
  // keyResultType:string,
  // startValue:string,
  
//   const addKeyResultSchema=yup.object().shape({
//     name:yup.string().required(),
//     responsibleId:yup.string().required(''),
//     pointingSystemType:yup.string().required(''),
//     keyResultType:yup.string().required(''),
//     startValue:yup.string().required(''),
//     weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
//   })
  
  
//   const editKeyResultSchema=yup.object().shape({
//     name:yup.string().required(),
//     responsibleId:yup.string().required(''),
//     pointingSystemType:yup.string().required(''),
//     keyResultType:yup.string().required(''),
//     startValue:yup.string().required(''),
//     weight:yup.number().typeError('مقدار وزن میبایست عدد باشد').nullable().min(0,'حداقل 0').max(100,'حداکثر 100')
//   })
  
  
  
  export   {
      addIndexSchema
      // addObjectiveInitialValues,      
  }